import { Trans } from 'react-i18next';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { CompetitionManagerAssignedNotificationData } from './interfaces';

const isCompetitionManagerAssignedPayload = (
  payload: unknown
): payload is CompetitionManagerAssignedNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'competitionName' in payload && typeof payload.competitionName === 'string'
  );
};

export const competitionManagerAssignedPresenter: NotificationPresenter<CompetitionManagerAssignedNotificationData> =
  {
    type: 'competition-manager-assigned',
    icon: EmojiEventsIcon,
    badgeIcon: GroupAddIcon,
    isPayload: isCompetitionManagerAssignedPayload,
    label: (payload, t) =>
      t('notifications:types.competition-manager-assigned', {
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.competition-manager-assigned"
        values={{
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return ROUTES.manage.competitions.details(payload.competitionSlug);
    },
  };
